export class Product {
  name: string;
  order: number;
  description: string;
  price: number;
  metaTags: string[];
  hidden: boolean;
  select: boolean;
}
